<app-window-title icon="assignment_ind"
                  [closable]="true"
                  [title]="'Create ' + Labels.clientMatterLabel"
                  (closed)="dialogRef.close()">

</app-window-title>
<div class="create-patient-content"
     mat-dialog-content>
  <app-loader *ngIf="!ownerID"
              message="please wait..."></app-loader>
  <!-- MRN collision panel: Hub owns a patient with this ID, Spoke confirms identity and enters their own MRN -->
  <div *ngIf="ownerID && state === 'mrn-collision'"
       class="duplicate-found-panel">
    <app-loader *ngIf="mrnCollisionLoading" message="Looking up patient..."></app-loader>
    <ng-container *ngIf="!mrnCollisionLoading">
      <mat-icon class="duplicate-icon">link</mat-icon>
      <h3>Patient ID already registered</h3>
      <ng-container *ngIf="mrnCollisionPatient">
        <p>This Patient ID belongs to an existing patient in your network:</p>
        <div class="duplicate-patient-card">
          <div class="duplicate-field"><label>Name:</label> <span>{{ mrnCollisionPatient.lastName | uppercase }}, {{ mrnCollisionPatient.firstName | titlecase }}</span></div>
          <div class="duplicate-field"><label>Date of Birth:</label> <span>{{ mrnCollisionPatient.dob }}</span></div>
        </div>
        <p class="duplicate-question">Is this the same patient you are registering?</p>
        <div class="duplicate-actions">
          <button mat-flat-button color="primary" (click)="state = 'mrn-collision-confirm'">
            <mat-icon>check</mat-icon> Yes — link my facility's ID
          </button>
          <button mat-stroked-button (click)="cancelMrnCollision()">
            <mat-icon>close</mat-icon> No — use a different Patient ID
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="!mrnCollisionPatient">
        <p class="error-text">Could not retrieve patient information. Please use a different Patient ID.</p>
        <button mat-stroked-button (click)="cancelMrnCollision()">
          <mat-icon>arrow_back</mat-icon> Back to form
        </button>
      </ng-container>
    </ng-container>
  </div>

  <!-- MRN collision confirm: Spoke enters their own facility MRN -->
  <div *ngIf="ownerID && state === 'mrn-collision-confirm'"
       class="duplicate-found-panel">
    <mat-icon class="duplicate-icon">link</mat-icon>
    <h3>Enter your facility's Patient ID</h3>
    <p>Your facility's local Patient ID for <strong>{{ mrnCollisionPatient?.lastName | uppercase }}, {{ mrnCollisionPatient?.firstName | titlecase }}</strong> will be linked to this patient record.</p>
    <div class="mrn-collision-input">
      <mat-form-field appearance="outline">
        <mat-label>Your Facility Patient ID *</mat-label>
        <input matInput [(ngModel)]="mrnCollisionSpokePatientId" name="mrnCollisionSpokePatientId" />
        <mat-hint>e.g. SPOKE-456</mat-hint>
      </mat-form-field>
    </div>
    <p class="mrn-collision-note">
      <mat-icon style="font-size:16px;vertical-align:middle">info</mat-icon>
      A support case will be opened to review this link.
    </p>
    <div class="duplicate-actions">
      <button mat-flat-button color="primary"
              [disabled]="!mrnCollisionSpokePatientId?.trim() || mrnCollisionLinking"
              (click)="confirmMrnCollisionLink()">
        <mat-icon>save</mat-icon> {{ mrnCollisionLinking ? 'Linking...' : 'Confirm Link' }}
      </button>
      <button mat-stroked-button (click)="state = 'mrn-collision'" [disabled]="mrnCollisionLinking">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
    </div>
    <p *ngIf="errorMessage" class="error-text">{{ errorMessage }}</p>
  </div>

  <!-- Duplicate found panel -->
  <div *ngIf="ownerID && state === 'duplicate-found' && duplicatePatient"
       class="duplicate-found-panel">
    <mat-icon class="duplicate-icon">person_search</mat-icon>
    <h3>Possible duplicate found</h3>
    <p>A patient with a similar name and date of birth already exists in your network:</p>
    <div class="duplicate-patient-card">
      <div class="duplicate-field"><label>Name:</label> <span>{{ duplicatePatient.lastName | uppercase }}, {{ duplicatePatient.firstName | titlecase }}</span></div>
      <div class="duplicate-field"><label>Date of Birth:</label> <span>{{ duplicatePatient.dob }}</span></div>
    </div>
    <p class="duplicate-question">Is this the same patient?</p>
    <div class="duplicate-actions">
      <button mat-flat-button color="primary" (click)="confirmSamePatient()">
        <mat-icon>check</mat-icon> Yes — link my patient ID
      </button>
      <button mat-stroked-button (click)="confirmDifferentPatient()">
        <mat-icon>close</mat-icon> No — different patient
      </button>
    </div>
  </div>

  <!-- Hub merge-alert panel -->
  <div *ngIf="ownerID && state === 'hub-duplicate-found' && hubDuplicatePatient"
       class="duplicate-found-panel hub-merge-panel">
    <mat-icon class="duplicate-icon">warning</mat-icon>
    <h3>Possible merge case detected</h3>
    <p>A patient with a similar name and date of birth already exists in your records:</p>
    <div class="duplicate-patient-card">
      <div class="duplicate-field"><label>Name:</label> <span>{{ hubDuplicatePatient.lastName | uppercase }}, {{ hubDuplicatePatient.firstName | titlecase }}</span></div>
      <div class="duplicate-field"><label>Date of Birth:</label> <span>{{ hubDuplicatePatient.dob }}</span></div>
    </div>

    <!-- Inline add-patient-ID form -->
    <ng-container *ngIf="showHubMergeIdForm; else hubMergeActions">
      <p class="duplicate-question">Add new Patient ID to this existing record:</p>
      <div class="hub-merge-id-form">
        <mat-form-field appearance="outline" color="warn" class="hub-merge-field">
          <mat-label>Patient ID</mat-label>
          <input matInput [value]="hubMergePatientId" readonly />
          <mat-hint>From your form entry</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline" color="warn" class="hub-merge-field">
          <mat-label>Facility *</mat-label>
          <mat-select [(value)]="hubMergeSelectedFacility">
            <mat-option *ngFor="let f of facilities" [value]="f.id">{{ f.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="!hubMergeSelectedFacility">Facility is required</mat-error>
        </mat-form-field>
      </div>
      <p *ngIf="hubMergeError" class="error-text">{{ hubMergeError }}</p>
      <div class="duplicate-actions">
        <button mat-flat-button color="warn"
                [disabled]="!hubMergeSelectedFacility || hubMergeAddingId"
                (click)="confirmAddPatientIdToExisting()">
          <mat-icon>save</mat-icon> {{ hubMergeAddingId ? 'Saving...' : 'Confirm' }}
        </button>
        <button mat-stroked-button [disabled]="hubMergeAddingId" (click)="showHubMergeIdForm = false">
          <mat-icon>arrow_back</mat-icon> Back
        </button>
      </div>
    </ng-container>

    <ng-template #hubMergeActions>
      <p class="duplicate-question">Is this the same patient?</p>
      <div class="duplicate-actions hub-merge-actions">
        <button mat-flat-button color="warn" (click)="showAddIdToExistingForm()">
          <mat-icon>add_circle</mat-icon> Yes — Add Patient ID
        </button>
        <button mat-flat-button color="primary" (click)="viewExistingHubPatient()">
          <mat-icon>open_in_new</mat-icon> View Existing Patient
        </button>
        <button mat-stroked-button (click)="createAnywayHub()">
          <mat-icon>add</mat-icon> No — Create Anyway
        </button>
      </div>
    </ng-template>
  </div>

  <div *ngIf="ownerID && (state === 'form' || state === 'not-same-acknowledged')"
       class="patient-form-container">

    <!-- Acknowledgement banner when Spoke confirmed it's a different patient -->
    <div *ngIf="state === 'not-same-acknowledged'" class="not-same-banner">
      <mat-icon>warning</mat-icon>
      <span>A patient with a similar name and date of birth exists in your network. Please confirm this is a different person before proceeding.</span>
    </div>

    <form class="patient-form">
      <mat-tab-group #formTabGroup color="warn" class="form-tabs" [(selectedIndex)]="selectedTabIndex">

        <!-- Tab 1: Basic Information -->
        <mat-tab label="Basic Info">
          <div class="tab-content">
            <div class="form-row fx-row fx-gap-20">
              <div class="fx-flex">
                <mat-form-field class="full-width" color="warn" appearance="outline">
                  <mat-label>First name</mat-label>
                  <input #firstNameInput
                         id="firstNameInput"
                         required
                         type="text"
                         matInput
                         [value]="fname"
                         (input)="fname = firstNameInput.value">
                  <mat-error *ngIf="!fname?.trim()">Client must have a first name</mat-error>
                </mat-form-field>
              </div>
              <div class="fx-flex">
                <mat-form-field class="full-width" color="warn" appearance="outline">
                  <mat-label>Last name</mat-label>
                  <input #lastNameInput
                         id="lastNameInput"
                         required
                         type="text"
                         matInput
                         [value]="lname"
                         (input)="lname = lastNameInput.value">
                  <mat-error *ngIf="!lname?.trim()">Client must have a last name</mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- Patient IDs Section -->
            <div class="medical-records-section">
              <div class="section-header">
                <h4 class="subsection-title">Patient IDs</h4>
                <button *ngIf="isFirstPatientIDFilled() && userFacility"
                        class="add-patient-id-btn"
                        color="primary"
                        type="button"
                        mat-raised-button
                        (click)="addPatientIDNumber()">
                  <mat-icon>add</mat-icon>
                  <span>Add Patient ID</span>
                </button>
                <span *ngIf="isFirstPatientIDFilled() && userFacility" class="facility-info">
                  <mat-icon>info</mat-icon>
                  You can add additional patient IDs for other facilities
                </span>
                <span *ngIf="!isFirstPatientIDFilled() && userFacility" class="facility-info">
                  <mat-icon>info</mat-icon>
                  Fill in the first patient ID to add additional ones
                </span>
              </div>

              <div class="medical-records-container">
                <!-- Always show at least one Patient ID field -->
                <div *ngIf="patientIDs.length === 0"
                     class="medical-record-entry fx-row fx-col-lt-md fx-jc-start fx-ai-center fx-gap-16">
                  <div class="field-container fx-flex-45">
                    <mat-form-field class="full-width" color="warn" appearance="outline">
                      <mat-label>Patient ID</mat-label>
                      <input #patientIDInput
                             id="patientID_0"
                             name="patientID_0"
                             required
                             type="text"
                             matInput
                             [(ngModel)]="defaultPatientID.number">
                      <mat-error *ngIf="!defaultPatientID.number?.trim()">Patient ID is required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="field-container fx-flex-45">
                    <mat-form-field class="full-width" color="warn" appearance="outline">
                      <mat-label>Facility</mat-label>
                      <mat-select id="facility_default"
                                  name="facility_0"
                                  required
                                  [(value)]="defaultPatientID.facility"
                                  (selectionChange)="onDefaultFacilityChange($event.value)">
                        <mat-option *ngFor="let facility of getAvailableFacilitiesForDefault()" [value]="facility.id">
                          {{ facility.name }}
                        </mat-option>
                        <mat-option *ngIf="getAvailableFacilitiesForDefault().length === 0" disabled>
                          No facilities available
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="!defaultPatientID.facility">Facility selection is required</mat-error>
                      <mat-hint *ngIf="patientIDs.length > 0">Already-selected facilities are hidden</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="action-container fx-flex-10 fx-row fx-jc-center fx-ai-center">
                    <button class="add-default-patient-id-btn"
                            color="primary"
                            type="button"
                            mat-flat-button
                            (click)="addDefaultPatientID()">
                      <mat-icon>add</mat-icon>
                      <span>Add</span>
                    </button>
                  </div>
                </div>

                <!-- Show existing Patient ID entries -->
                <div *ngFor="let patientID of patientIDs; let i = index"
                     class="medical-record-entry fx-row fx-col-lt-md fx-jc-start fx-ai-center fx-gap-16">
                  <div class="field-container fx-flex-45">
                    <mat-form-field class="full-width" color="warn" appearance="outline">
                      <mat-label>Patient ID</mat-label>
                      <input name="patientID_{{i}}"
                             required
                             type="text"
                             matInput
                             [id]="'patientID_' + i"
                             [(ngModel)]="patientID.number">
                      <mat-error *ngIf="!patientID.number?.trim()">Patient ID is required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="field-container fx-flex-45">
                    <mat-form-field class="full-width" color="warn" appearance="outline">
                      <mat-label>Facility</mat-label>
                      <mat-select name="facility_{{i}}"
                                  required
                                  [disabled]="i === 0"
                                  [id]="'facility_' + i"
                                  [(value)]="patientID.facility"
                                  (selectionChange)="onFacilityChange($event.value, i)">
                        <mat-option *ngFor="let facility of getAvailableFacilities(i)" [value]="facility.id">
                          {{ facility.name }}
                        </mat-option>
                        <mat-option *ngIf="getAvailableFacilities(i).length === 0" disabled>
                          No facilities available
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="!patientID.facility">Facility selection is required</mat-error>
                      <mat-error *ngIf="patientID.facility && isFacilityAlreadySelected(patientID.facility, i)">
                        This facility is already selected for another patient ID
                      </mat-error>
                      <mat-hint *ngIf="i === 0">This is your facility - mandatory for the first patient ID</mat-hint>
                      <mat-hint *ngIf="i > 0">Select a facility (each can only be used once)</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="action-container fx-flex-10 fx-row fx-jc-center fx-ai-center">
                    <button *ngIf="i > 0"
                            color="warn"
                            type="button"
                            mat-icon-button
                            matTooltip="Remove this patient ID"
                            (click)="removePatientIDNumber(i)">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span *ngIf="i === 0" class="facility-locked">
                      <mat-icon>lock</mat-icon>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <mat-form-field class="full-width" color="warn" appearance="outline">
                <mat-label>Type</mat-label>
                <mat-select #typeSelect name="type" [(value)]="type">
                  <mat-option value="external">Facility Patients</mat-option>
                  <mat-option value="employee">Employee</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-tab>

        <!-- Tab 2: Personal Details -->
        <mat-tab label="Personal Details">
          <div class="tab-content">
            <div class="form-row fx-row fx-gap-20">
              <div class="fx-flex">
                <mat-form-field class="full-width" color="warn" appearance="outline">
                  <mat-label>Date of birth</mat-label>
                  <input #dateOfBirthInput
                         id="dateOfBirthInput"
                         required
                         matInput
                         [formControl]="date"
                         [matDatepicker]="picker"
                         [max]="maxDate"
                         (focus)="openDatepickerIfEmpty()">
                  <mat-datepicker-toggle color="warn" matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error *ngIf="!date.value">Date of birth is required</mat-error>
                </mat-form-field>
              </div>
              <div class="fx-flex">
                <mat-form-field class="full-width" color="warn" appearance="outline">
                  <mat-label>Gender</mat-label>
                  <mat-select #genderSelect id="genderSelect" name="gender" required [(value)]="gender">
                    <mat-option value="male">Male</mat-option>
                    <mat-option value="female">Female</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!gender || gender === ''">Gender selection is required</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="form-row">
              <mat-form-field class="full-width" color="warn" appearance="outline">
                <mat-label>Spouse name</mat-label>
                <input #spouseNameInput
                       type="text"
                       matInput
                       [value]="spouseName"
                       (input)="spouseName = spouseNameInput.value">
                <mat-hint>Optional</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </mat-tab>

        <!-- Tab 3: Contact & Photo -->
        <mat-tab label="Contact & Photo">
          <div class="tab-content">
            <div class="form-row fx-row fx-gap-20">
              <div class="fx-flex">
                <mat-form-field class="full-width" color="warn" appearance="outline">
                  <mat-label>Cell phone number</mat-label>
                  <input #cellPhoneNumberInput
                         type="text"
                         matInput
                         [value]="cellPhoneNumber"
                         (input)="cellPhoneNumber = cellPhoneNumberInput.value">
                  <mat-hint>Optional</mat-hint>
                </mat-form-field>
              </div>
              <div class="fx-flex">
                <mat-form-field class="full-width" color="warn" appearance="outline">
                  <mat-label>Email address</mat-label>
                  <input #emailAddressInput
                         id="emailAddressInput"
                         type="email"
                         matInput
                         [value]="emailAddress"
                         (input)="emailAddress = emailAddressInput.value">
                  <mat-error *ngIf="emailAddress && !isValidEmail(emailAddress)">
                    Please enter a valid email address
                  </mat-error>
                  <mat-hint>Optional</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="form-row">
              <div class="profile-image-section">
                <mat-form-field class="full-width" color="warn" appearance="outline">
                  <mat-label>Profile Picture</mat-label>
                  <input readonly matInput [value]="profileImage?.name || ''">
                  <button type="button" mat-icon-button matSuffix (click)="fileInput.click()">
                    <mat-icon>attach_file</mat-icon>
                  </button>
                  <mat-hint>Optional. Supported formats: JPG, JPEG, PNG, GIF. Maximum size: 5MB</mat-hint>
                </mat-form-field>

                <input #fileInput
                       id="profileImageInput"
                       class="file-input-hidden"
                       accept="image/jpeg,image/jpg,image/png,image/gif"
                       type="file"
                       (change)="onProfileImageSelected($event)">

                <!-- Image Preview -->
                <div *ngIf="profileImagePreview" class="profile-image-preview-section">
                  <div class="profile-image-container">
                    <img class="profile-image-preview" alt="Profile Preview" [src]="profileImagePreview">
                    <button class="remove-image-button" color="warn" mat-mini-fab (click)="removeProfileImage()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                </div>

                <!-- Upload Progress -->
                <div *ngIf="isUploadingImage" class="upload-progress-container">
                  <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
                  <span>Uploading image...</span>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

      </mat-tab-group>
    </form>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
  </div>
</div>
<mat-dialog-actions *ngIf="ownerID && state !== 'duplicate-found' && state !== 'hub-duplicate-found' && state !== 'mrn-collision' && state !== 'mrn-collision-confirm'"
                    class="dialog-actions-container">
  <!-- Legend section for missing required fields - aligned to left -->
  <div *ngIf="getMissingRequiredFields().length > 0"
       class="missing-fields-legend">
    <div class="legend-header">
      <mat-icon class="legend-icon">
        warning
      </mat-icon>
      <span class="legend-title">
        Required fields missing (click to focus):
      </span>
    </div>
    <div class="legend-fields">
      <span *ngFor="let field of getMissingRequiredFields(); let last = last"
            class="legend-field">
        <a class="field-link"
           href="javascript:void(0)"
           title="Click to focus on {{ field.label }}"
           [attr.data-field-id]="field.elementId"
           (mouseup)="onMouseUp(field.label)">
          {{ field.label }}
        </a>
        <span *ngIf="!last"
              class="field-separator">
          ,
        </span>
      </span>
    </div>
  </div>

  <!-- Normal create button -->
  <div *ngIf="state === 'form'" class="button-container">
    <button color="warn"
            mat-flat-button
            [disabled]="isUploadingImage || !isFormValid()"
            (click)="createPatient()">
      CREATE {{ Labels.clientMatterLabel | uppercase }}
    </button>
  </div>

  <!-- Acknowledged different-patient create button -->
  <div *ngIf="state === 'not-same-acknowledged'" class="button-container not-same-actions">
    <mat-checkbox [(ngModel)]="notSameAcknowledged" color="warn">
      I confirm this is a different patient
    </mat-checkbox>
    <button color="warn"
            mat-flat-button
            [disabled]="isUploadingImage || !isFormValid() || !notSameAcknowledged"
            (click)="proceedWithNewPatientCreation()">
      CREATE {{ Labels.clientMatterLabel | uppercase }}
    </button>
  </div>
</mat-dialog-actions>
